// extracted by mini-css-extract-plugin
module.exports = {"item":"ItemList_item__Im1Dn","list":"ItemList_list__YbjCk"};